import { Directive, ElementRef, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { PropertiesSettings } from '../../../../core/configuration/properties-settings';
import { HelpersService } from '../../../../core/services/helpers.service';
import { OperationsService } from '../../../../core/services/operations.service';
import {
  ParcellaStragiudizialeAdapter
} from '../../../components/fascicolo/parcelle-stragiudiziali-edit/parcella-stragiudiziale-adapter';
import { CompetenzaParcella } from '../../../models/competenza-parcella';


import { SezioneEconomicaResponse } from '../../../models/dto/sezione-economica-response';

import { SezioneLegaliResponse } from '../../../models/dto/sezione-legali-response';
import { LegaleIncaricato } from '../../../models/legale-incaricato';
import { ParcellaStragiudiziale } from '../../../models/parcella-stragiudiziale';

import { QuadroCompensiParcella } from '../../../models/quadro-compensi-parcella';
import { ScaglioneParcella } from '../../../models/scaglione-parcella';
import { SezioneEconomica } from '../../../models/sezioni/sezione-economica';
import { SezioneLegali } from '../../../models/sezioni/sezione-legali';
import { Categoria } from '../../../models/tipologiche/categoria';
import { Cpa } from '../../../models/tipologiche/cpa';
import { FaseCompensoParcella } from '../../../models/tipologiche/fase-compenso-parcella';
import { Iva } from '../../../models/tipologiche/iva';

import { ValoriRiferimentoParcella } from '../../../models/valori-riferimento-parcella';
import { NumericOperationManager } from '../../../utils/numeric-operation-manager';
import { BaseForm } from '../../base-Form';
import { ParcellaStragiudizialeQuadroPercentualeForm } from './parcella-stragiudiziale-quadro-percentuale-form';
import { ParcellaStragiudizialeQuadroTabellareForm } from './parcella-stragiudiziale-quadro-tabellare-form';

declare var removeEmptyObject: any;
declare var $: any;

@Directive()
export abstract class ParcellaStragiudizialeForm extends BaseForm {
  readonly PROPERTIES_SETTINGS = PropertiesSettings;
  parcellaStragiudiziale: ParcellaStragiudiziale;
  // form
  request: ParcellaStragiudiziale;
  riepilogo: ParcellaStragiudiziale = null;
  parcellaStragiudizialeForm: FormGroup;
  msgNoBeneficiari: string;

  // options
  tipiLegale: Categoria[] = [];
  legaliAll: LegaleIncaricato[] = [];
  legaliOptions: LegaleIncaricato[] = [];
  competenzeOptions: CompetenzaParcella[] = [];
  scaglioniOptions: ScaglioneParcella[] = [];
  valoriRiferimentoParcellaOptions: ValoriRiferimentoParcella[] = [];
  ivaOptions: Iva[] = [];
  cpaOptions: Cpa[] = [];

  // parametri abstract
  abstract getParcellaStragiudiziale(): ParcellaStragiudiziale;
  abstract getRequest(request: ParcellaStragiudiziale);
  abstract getUrlReadSezioneLegali(): string;
  abstract getUrlReadSezioneEconomica(): string;
  abstract getUrlGetScaglioni(): string;
  abstract getTipoFascicolo(): any;
  abstract getTipoPratica(): any;
  abstract getIdFascicolo(): string;

  // importi calcolati
  totaleQuadroCompensi: any = 0;

  // variabili
  quadroCompensi: QuadroCompensiParcella[] = [];
  idCompetenza: string;
  importoPetitum: any;
  isDisabledScaglioni: boolean = false;
  isDisabledValore: boolean = true;
  isCheckedTabellare: boolean;
  percentualeVal: string;
  importoBase: any;

  // toggle html
  visibleToggleAssocia: boolean = false;
  visibleToggleForm: boolean = false;
  visibleToggleRiepilogo: boolean = false;

  @ViewChild('quadroCompensiTabellareForm') quadroCompensiTabellareForm: ParcellaStragiudizialeQuadroTabellareForm;
  @ViewChild('quadroCompensiPercentualeForm') quadroCompensiPercentualeForm: ParcellaStragiudizialeQuadroPercentualeForm;
  @ViewChild('searchItem') searchItemRef!: ElementRef;

  constructor(protected operationService: OperationsService, private campiForm: FormBuilder, private helpers: HelpersService) {
    super();
  }

  initRequest() {
    this.request = new ParcellaStragiudizialeAdapter(this.getParcellaStragiudiziale()).parcellaStragiudiziale;
    this.request.flagParcella = true;
    this.importoBase = this.request.importoBase;
    /*if (!this.request.spesa.percSpesaGenerale) {
      this.request.spesa.percSpesaGenerale = 0;
    }*/

    if (this.quadroCompensiTabellareForm) {
      this.quadroCompensiTabellareForm.resetQuadroCompensi();
    }

    if (this.quadroCompensiPercentualeForm) {
      this.quadroCompensiPercentualeForm.resetQuadroCompensi();
    }
    if(this.request.competenza && this.request.scaglione){
      this.operationService.getScaglioniByFascicolo(this.getUrlGetScaglioni(), this.getIdFascicolo(), this.request.competenza.id).subscribe(response => this.getValoriFromScaglioniByFascicolo(response));
    }
    this.initViewToggle();
    this.populateSelect();
  }


  initViewToggle() {
    this.visibleToggleAssocia = false;
    this.visibleToggleForm = true;
    this.visibleToggleRiepilogo = false;

    if (this.inserimento) {
      this.visibleToggleAssocia = true;
      this.visibleToggleForm = false;
    }
  }

  createForm() {
    this.request = new ParcellaStragiudizialeAdapter(this.getParcellaStragiudiziale()).parcellaStragiudiziale;
    this.request.flagParcella = true;
    this.parcellaStragiudizialeForm = this.campiForm.group({
      id: [this.request.id],
      legale: [this.request.legale],
      tipoLegale: [this.request.legale ? this.request.legale.categoriaLegaleIncaricato : null],
      dataParcella: [this.request.dataParcella, Validators.required],
      numeroParcella: [this.request.numeroParcella],
      competenza: [this.request.competenza],
      scaglione: [this.request.scaglione],
      importoBase: [this.request.importoBase],
      percentualeImportoBase: [this.request.percentualeImportoBase],
      flagIva: [this.request.flagIva],
      iva: [this.request.iva],
      flagCpa: [this.request.flagCpa],
      cpa: [this.request.cpa],
      flagRitenutaAcconto: [this.request.flagRitenutaAcconto],
      importoParcella: [this.request.importoParcella],
      importoPetitumRiferimento: [this.request.importoPetitumRiferimento],
      spesa: [this.request.spesa],
      spesaEsente: [this.request.spesa && this.request.spesa.spesaEsente ? this.request.spesa.spesaEsente : 0],
      spesaTrasferta: [this.request.spesa && this.request.spesa.spesaTrasferta ? this.request.spesa.spesaTrasferta : 0],
      altraSpesaImponibile: [this.request.spesa && this.request.spesa.altraSpesaImponibile ? this.request.spesa.altraSpesaImponibile : 0],
      flagSpesaGenerale: [this.request.spesa ? this.request.spesa.flagSpesaGenerale : false],
      percSpesaGenerale: [this.request.spesa ? this.request.spesa.percSpesaGenerale : 0],
      fasiCompensi: [this.request.fasiCompensi],
      note: [this.request.note],
      documenti: [this.request.documenti],
      maggiorazione: [this.request.maggiorazione],
      contributoUnificato: [this.request.contributoUnificato]
    });
    this.initRequest();
  }

  public setTextEmpty() {
    this.searchItemRef.nativeElement.value = '';
  }

  formValid(): boolean {
    let result: boolean = false;
    if (!this.isCheckedTabellare && (this.request.importoPetitumRiferimento && this.request.importoPetitumRiferimento.toString().trim().length !== 0 && this.request.importoPetitumRiferimento > 0) && (this.percentualeVal && this.percentualeVal.toString().trim().length !== 0) && (!this.request.spesa || (this.request.spesa && this.request.spesa.percSpesaGenerale && this.request.spesa.percSpesaGenerale > 0)) && this.checkIvaCpa() && this.checkAtLeastOneFasePercentuale()) {
      result = true;
    }
    if (this.isCheckedTabellare && this.request.scaglione && (!this.request.spesa || (this.request.spesa && this.request.spesa.percSpesaGenerale && this.request.spesa.percSpesaGenerale > 0)) && this.checkIvaCpa() && this.checkAtLeastOneFaseTabellare()) {
      result = true;
    }
    return result;
  }

  checkAtLeastOneFaseTabellare(): boolean {
    let result: boolean = false;
    if (this.quadroCompensiTabellareForm && this.quadroCompensiTabellareForm.checkAtLeastOneFase() && this.quadroCompensiTabellareForm.checkAtLeastOneCompenso()) {
      result = true;
    }
    return result;
  }

  checkAtLeastOneFasePercentuale(): boolean {
    let result: boolean = false;
    if (this.quadroCompensiPercentualeForm && this.quadroCompensiPercentualeForm.checkAtLeastOneFase() && this.quadroCompensiPercentualeForm.checkAtLeastOneCompenso()) {
      result = true;
    }
    return result;
  }

  checkIvaCpa(): boolean {
    let result: boolean = false;
    if (this.request.flagCpa) {
      if (this.request.cpa && this.request.cpa.id !== '-1') {
        result = true;
      }
    } else {
      result = true;
    }
    if (result) {
      if (this.request.flagIva) {
        if (this.request.iva && this.request.iva.id !== '-1') {
          result = true;
        } else {
          result = false;
        }
      } else {
        result = true;
      }
    }
    return result;
  }


  populateSelect() {
    if (this.tipiLegale.length === 0) {
      this.helpers.getCategorieLegaleIncaricato().subscribe(response => this.tipiLegale = response);
    }
    if (this.ivaOptions.length === 0) {
      this.helpers.getIva().subscribe(response => this.ivaOptions = response);
    }
    if (this.cpaOptions.length === 0) {
      this.helpers.getCpa().subscribe(response => this.cpaOptions = response);
    }
    if (this.competenzeOptions.length === 0) {
      this.helpers.getCompetenzeParcellaPratFasc(this.getTipoPratica(), this.getTipoFascicolo()).subscribe(response =>{this.competenzeOptions = response;});
    } else {
      this.initModeTabellareOPercentuale();
    }
  }

  populateScaglioniFromCompetenza(idCompetenza: string) {
    this.request.scaglione = null;
    this.operationService.getScaglioniByFascicolo(this.getUrlGetScaglioni(), this.getIdFascicolo(), idCompetenza).subscribe(response => this.getValoriFromScaglioniByFascicolo(response));
  }

  initModeTabellareOPercentuale() {
    if ((this.parcellaStragiudiziale && this.request.scaglione && this.request.scaglione.id !== '-1') || this.inserimento) {
      this.isCheckedTabellare = false;
      this.setModeTabellare();
    } else {
      this.isCheckedTabellare = true;
      this.setModePercentuale();
    }

  }

  getValoriFromScaglioniByFascicolo(response) {
    this.scaglioniOptions = response.scaglioni;
    this.initModeTabellareOPercentuale();
  }

  populateScaglioni() {
    /*for (let s of this.scaglioniOptions) {debugger
      if (this.request.importoPetitumRiferimento) {
        if (this.request.importoPetitumRiferimento  > 0 && s.importoMinimo <= this.request.importoPetitumRiferimento && this.request.importoPetitumRiferimento <= s.importoMassimo) {
          this.request.scaglione = s;
          this.populateFasiCompenso(s.id);
          this.isDisabledScaglioni = true;
          break;
        }
      }
    }*/ //non serve il for perch il tabellare non ha il valore importPetitumRiferimento
    console.log(this.request.scaglione)
    if (!this.inserimento && this.isCheckedTabellare && this.request.scaglione) {
      this.populateFasiCompenso(this.request.scaglione.id);
    }
    //    if (!this.isDisabledScaglioni) {
    //      if (!this.request.scaglione) {
    //        this.request.scaglione = this.scaglioniOptions[0];
    //      }
    //      this.populateFasiCompenso(this.request.scaglione.id);
    //      this.isDisabledScaglioni = true;
    //    }
  }

  setModeTabellare() {
    if (!this.isCheckedTabellare) {
      this.quadroCompensiTabellareForm.resetQuadroCompensi();
      if (this.importoPetitum) {
        this.request.importoPetitumRiferimento = this.importoPetitum;
      } else {
        this.request.importoPetitumRiferimento = 0;
      }
      this.request.importoPetitumRiferimento = this.request.importoPetitumRiferimento;
      this.isCheckedTabellare = true;
      this.percentualeVal = '';
      this.populateScaglioni();
    }
    this.parcellaStragiudizialeForm.controls['competenza'].setValidators([Validators.required]);
    this.parcellaStragiudizialeForm.controls['competenza'].updateValueAndValidity();
    this.parcellaStragiudizialeForm.controls['scaglione'].setValidators([Validators.required]);
    this.parcellaStragiudizialeForm.controls['scaglione'].updateValueAndValidity();
    this.parcellaStragiudizialeForm.controls['importoPetitumRiferimento'].setValidators([]);
    this.parcellaStragiudizialeForm.controls['importoPetitumRiferimento'].updateValueAndValidity();
    this.parcellaStragiudizialeForm.controls['percentualeImportoBase'].setValidators([]);
    this.parcellaStragiudizialeForm.controls['percentualeImportoBase'].updateValueAndValidity();
  }

  setModePercentuale() {
    if (this.isCheckedTabellare) {
      this.quadroCompensiPercentualeForm.resetQuadroCompensi();
      this.isDisabledScaglioni = true;
      this.isCheckedTabellare = false;
      if (!this.request.percentualeImportoBase) {
        this.percentualeVal = '5';
      } else {
        this.percentualeVal = this.request.percentualeImportoBase;
      }
      this.quadroCompensiPercentualeForm.valorePercentuale = this.percentualeVal;
      this.request.importoPetitumRiferimento = this.request.importoPetitumRiferimento;
      this.inizializzaQuadro();
      //this.populateScaglioni();
      this.request.competenza = null;
      this.request.scaglione = null;
    }
    this.parcellaStragiudizialeForm.controls['competenza'].setValidators([]);
    this.parcellaStragiudizialeForm.controls['competenza'].updateValueAndValidity();
    this.parcellaStragiudizialeForm.controls['scaglione'].setValidators([]);
    this.parcellaStragiudizialeForm.controls['scaglione'].updateValueAndValidity();
    this.parcellaStragiudizialeForm.controls['importoPetitumRiferimento'].setValidators([Validators.required]);
    this.parcellaStragiudizialeForm.controls['importoPetitumRiferimento'].updateValueAndValidity();
    this.parcellaStragiudizialeForm.controls['percentualeImportoBase'].setValidators([Validators.required]);
    this.parcellaStragiudizialeForm.controls['percentualeImportoBase'].updateValueAndValidity();
  }

  populateFasiCompenso(idScaglione: string) {
    if (idScaglione !== '-1') {
      this.helpers.getValoriRiferimentiParcellaByScaglione(idScaglione).subscribe(response => { this.getValoriRiferimento(response); });
    }
  }

  getValoriRiferimento(response) {
    this.valoriRiferimentoParcellaOptions = response;
    this.inizializzaQuadro();
  }

  onChangePercentuale(_value: string) {
    this.percentualeVal = _value;
    this.quadroCompensiPercentualeForm.valorePercentuale = this.percentualeVal;
    this.inizializzaQuadro();
  }


  onChangePetitum(_value: string) {
    this.request.importoPetitumRiferimento = _value;
    this.quadroCompensiPercentualeForm.valorePetitum = this.request.importoPetitumRiferimento;
    this.inizializzaQuadro();
  }

  validate(event: any, _value: string) {
    this.quadroCompensiPercentualeForm.validate(event, _value);
  }

  inizializzaQuadro() {
    if(this.isCheckedTabellare){
      this.parcellaStragiudizialeForm.controls['scaglione'].setValue(this.request.scaglione)
    }
    if (this.quadroCompensiTabellareForm && this.quadroCompensiPercentualeForm) {
      if (this.isCheckedTabellare) {
        this.quadroCompensiTabellareForm.valoriRiferimentoParcella = this.valoriRiferimentoParcellaOptions;
        this.quadroCompensiTabellareForm.fasiCompensi = this.request.fasiCompensi;
        this.quadroCompensiTabellareForm.createQuadroCompensi();
      } else {
        this.quadroCompensiPercentualeForm.valoriRiferimentoParcella = this.valoriRiferimentoParcellaOptions;
        this.quadroCompensiPercentualeForm.fasiCompensi = this.request.fasiCompensi;
        this.quadroCompensiPercentualeForm.createQuadroCompensi(this.percentualeVal, this.request.importoPetitumRiferimento, this.importoBase);
      }

    }
  }

  save() {
    this.getRequest(this.riepilogo);
  }

  readSezioneLegali(idSezioneLegali: string) {
    if (idSezioneLegali) {
      this.operationService.readSezione(this.getUrlReadSezioneLegali(), idSezioneLegali)
        .subscribe(response => this.readSezioneLegaliResponse((<SezioneLegaliResponse>response).sezione));
    }
  }

  readSezioneLegaliResponse(sezioneLegali: SezioneLegali) {
    this.legaliAll = sezioneLegali.legaliIncaricati;
    this.legaliAll = this.legaliAll.filter(legaleIncaricato => { return legaleIncaricato.revocato === false; });
    this.msgNoBeneficiari = 'Non esistono beneficiari da associare';
    if (this.getParcellaStragiudiziale() && !this.inserimento) {
      this.legaliOptions = this.legaliAll.filter(legaleIncaricato => { return legaleIncaricato.categoriaLegaleIncaricato.id === this.getParcellaStragiudiziale().legale.categoriaLegaleIncaricato.id; });
    }
  }

  readSezioneEconomica(idSezioneDatiEconomici: string) {
    if (idSezioneDatiEconomici) {
      this.operationService.readSezione(this.getUrlReadSezioneEconomica(), idSezioneDatiEconomici)
        .subscribe(response => this.readSezioneEconomicaResponse((<SezioneEconomicaResponse>response).sezione));
    }
  }

  readSezioneEconomicaResponse(sezioneEconomica: SezioneEconomica) {
    if (!this.parcellaStragiudiziale) {
      this.importoPetitum = sezioneEconomica.petitum.importoPetitum;
    } else {
      this.importoPetitum = this.parcellaStragiudiziale.importoPetitumRiferimento;
    }
    this.request.importoPetitumRiferimento = this.importoPetitum;
  }

  populateLegali(event: any) {
    if (event.target.value && this.legaliAll.length > 0) {
      this.legaliOptions = this.legaliAll.filter(legale => { return legale.categoriaLegaleIncaricato.id === event.target.value; });
    }
  }

  calcolaCompenso(obj: any) {
    this.getLegale(obj);
    let newFasiCompenso: FaseCompensoParcella[] = [];
    for (let f of this.quadroCompensi) {
      let fase: FaseCompensoParcella = new FaseCompensoParcella();
      if (f.checkedFase) {
        fase.fase = f.fase;
        if (typeof f.compenso === 'string') {
          fase.compenso = this.stringToNumber(f.compenso);
        } else {
          fase.compenso = f.compenso;
        }
        newFasiCompenso.push(fase);
      }
    }
    if (this.request.spesa && this.request.spesa.percSpesaGenerale && Number(this.request.spesa.percSpesaGenerale) > 0) {
      this.request.spesa.flagSpesaGenerale = true;
    } else {
      this.request.spesa.flagSpesaGenerale = false;
    }
    this.request.fasiCompensi = newFasiCompenso;
    if (!this.isCheckedTabellare) {
      this.request.fasiCompensi = null;
      //this.request.percentualeImportoBase = this.percentualeVal;
      this.request.importoBase = '' + newFasiCompenso[0].compenso;
    }
    //this.request.importoPetitumRiferimento = this.request.importoPetitumRiferimento;
    this.calcolaTotaleDocumento(this.request);
  }

  calcolaTotaleDocumento(parcellaStragiudiziale: ParcellaStragiudiziale) {
    parcellaStragiudiziale.importoBase = this.stringToNumber('' + parcellaStragiudiziale.importoBase);
    this.helpers.buildProspettoParcella(parcellaStragiudiziale).subscribe(response => this.getTotaleDocumento(response));
  }

  getTotaleDocumento(parcellaStragiudiziale: ParcellaStragiudiziale) {
    this.goToRiepilogo(parcellaStragiudiziale);
  }

  goToRiepilogo(parcellaStragiudiziale: ParcellaStragiudiziale) {
    this.riepilogo = parcellaStragiudiziale;
    this.visibleToggleRiepilogo = true;
    this.visibleToggleForm = false;
  }

  goToAssociaLegale() {
    this.createForm();
    this.visibleToggleAssocia = true;
    this.visibleToggleForm = false;
  }

  goToForm() {
    this.visibleToggleRiepilogo = false;
    this.visibleToggleForm = true;
  }

  associaLegale(legaleIncaricato: LegaleIncaricato) {
    this.getLegale(legaleIncaricato);
    this.visibleToggleAssocia = false;
    this.visibleToggleForm = true;
  }

  getLegale(obj: any) {
    if (obj.id) {
      this.request.legale = this.legaliAll.filter(legale => { return legale.id === obj.id; })[0];
    }
  }

  getSum(...args: string[]) {
    return NumericOperationManager.getSum(args);
  }

  stringToNumber(value: string): number {
    value = value.replace(',', '.');
    return Number(value);
  }

  refresh(quadroCompensiParcella: QuadroCompensiParcella[]) {
    this.quadroCompensi = quadroCompensiParcella;
    this.totaleQuadroCompensi = 0;
    for (let q of quadroCompensiParcella) {
      if (q.checkedFase) {
        this.totaleQuadroCompensi = this.getSum(this.totaleQuadroCompensi, q.compenso);
      }
    }
    this.request.importoBase = this.totaleQuadroCompensi;
  }

  private getBeneficiarioLabel(legaleIncaricato: LegaleIncaricato): string {
    let result = '';
    if (legaleIncaricato && legaleIncaricato.legale && legaleIncaricato.legale.tipoPersona) {
      if (legaleIncaricato.legale.tipoPersona.label === PropertiesSettings.LABEL_TIPO_PERSONA_FISICA) {
        result = legaleIncaricato.legale.cognome + ' ' + legaleIncaricato.legale.nome;
      }
      if (legaleIncaricato.legale.tipoPersona.label === PropertiesSettings.LABEL_TIPO_PERSONA_GIURIDICA) {
        result = legaleIncaricato.legale.ragioneSociale;
      }
    }
    return result;
  }

}
